<template>
    <v-card class="fill-height">
        <v-card-title primary-title>
            <h3 class="headline">Questionnaire</h3>
            <v-spacer></v-spacer>
            <v-btn right color="primary" :to="{ name: 'survey.add' }">
                <v-icon>add</v-icon>
                Créer un questionnaire
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout align-center justify-end row>
                <v-flex xs6>
                    <v-tabs
                        v-model="active"
                        slider-color="primary">
                        <v-tab ripple>
                            Actives
                        </v-tab>
                        <v-tab ripple>
                            Archivées
                        </v-tab>
                    </v-tabs>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Recherche"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-data-table
            class="mx-4"
            :headers="headers"
            :items="active === 0 ? getActiveScores : getArchivedScores"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <router-link tag="tr" :to="{name: 'survey.view', params: { id: props.item.id } }">
                    <td>{{ $t(props.item.type)}}</td>
                    <td>{{ props.item.name }}</td>
                    <td v-html="props.item.instructions"></td>
                    <td>{{ props.item.rule }}</td>
                    <td>{{ props.item.extra }}</td>
                </router-link>

            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
    name: "SurveyList",
    data() {
        return {
            has_error: false,
            search: '',
            active: 0,
            headers: [
                {text: 'Type', align: 'left', value: 'type'},
                {text: 'Nom', align: 'left', value: 'name'},
                {text: 'Instructions', align: 'left', value: 'instructions'},
                {text: 'Rêgle', align: 'left', value: 'rule'},
                {text: 'Extra', align: 'left', value: 'extra'}
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'name',
                //descending:true
            }
        }
    },

    computed: {
        ...mapState({
            scores: state => state.studies.scores
        }),
        ...mapGetters('studies', [
            'getArchivedScores',
            'getActiveScores'
        ]),
    },

    mounted() {
        this.getAllScores()
    },
    methods: {
        ...mapActions('studies', [
            'getAllScores',
        ])
    }
}
</script>
